// Normalizes invalid runtime locale tags (e.g. "en-US@posix" from C.UTF-8
// environments) so Intl constructors used by recharts/formatters never throw.
(function normalizeLocale() {
  const SAFE = "en-US";
  const bad = (tag) => typeof tag === "string" && (tag.includes("@") || tag.includes("posix"));
  const sanitize = (locales) => {
    if (locales == null) return SAFE;
    if (Array.isArray(locales)) {
      const cleaned = locales.map((l) => (bad(l) ? SAFE : l)).filter(Boolean);
      return cleaned.length ? cleaned : SAFE;
    }
    return bad(locales) ? SAFE : locales;
  };

  try {
    const lang = navigator.language;
    if (bad(lang)) {
      Object.defineProperty(navigator, "language", { value: SAFE, configurable: true });
      Object.defineProperty(navigator, "languages", { value: [SAFE], configurable: true });
    }
  } catch (_) { /* ignore */ }

  ["NumberFormat", "DateTimeFormat", "Collator", "PluralRules", "RelativeTimeFormat"].forEach((name) => {
    const Original = Intl[name];
    if (!Original) return;
    const Wrapped = function (locales, options) {
      return new Original(sanitize(locales), options);
    };
    Wrapped.prototype = Original.prototype;
    Wrapped.supportedLocalesOf = (locales, options) =>
      Original.supportedLocalesOf(sanitize(locales), options);
    Intl[name] = Wrapped;
  });

  const origToLocaleString = Number.prototype.toLocaleString;
  Number.prototype.toLocaleString = function (locales, options) {
    return origToLocaleString.call(this, sanitize(locales), options);
  };
  const origDateToLocale = Date.prototype.toLocaleString;
  Date.prototype.toLocaleString = function (locales, options) {
    return origDateToLocale.call(this, sanitize(locales), options);
  };
  const origDateStr = Date.prototype.toLocaleDateString;
  Date.prototype.toLocaleDateString = function (locales, options) {
    return origDateStr.call(this, sanitize(locales), options);
  };
})();
